import { useLeagueContext } from '../context/LeagueProvider';

export const useCurrentWeek = () => {
  const {
    data: { week: currentWeek = 0, getSimulationStatus: simStatus },
  } = useLeagueContext();

  return { currentWeek, simStatus };
};
